import React from 'react'
import ContractsTable from 'components/ContractsTable'
import useFilters from '@byma/shared/hooks/useFilters'
import dayjs from 'dayjs'
import Link from 'next/link'
import Image from 'next/image'
import Router, { useRouter } from 'next/router'
import useToastContext from "@byma/shared/hooks/useToastContext";
import Layout from 'components/Layout'
import { methodParser, money } from '@byma/shared/helpers/formatters'
import useAuth from '@byma/shared/hooks/useAuth'
import { FiCopy, FiArrowLeft, FiArrowRight, FiArrowLeftCircle } from 'react-icons/fi'
import { ImWhatsapp } from 'react-icons/im'
import useSWR from 'swr'
import fetcher from '@byma/shared/helpers/fetcher'
import { getContractValidity, contractStatusLabel } from '@byma/shared/helpers/contracts'
import Breadcrumbs from '@byma/shared/components/Breadcrumbs'
import jwt from 'jsonwebtoken'
import Loader from '@byma/shared/components/Loader'

const breadcrumbPaths = [
    { label: 'Contratos', url: `/contracts` },
]

export default function Contracts() {
    const session = useAuth()
    let { query, ...router } = useRouter()
    const { contractId } = query
    const { token, user: currentUser } = session
    const { originalQueryString } = useFilters(query)

    const { data: contractSelected } = useSWR(token && contractId ? ['/api/contracts/get?contractId=' + contractId, null, token] : null, fetcher)

    function isExpired(contract) {
        return dayjs().isAfter(contract.expires_at)
    }

    return (
        <Layout {...{ session }}>
            <div className="flex flex-col h-full">
                <div className="p-3">
                    <Breadcrumbs paths={breadcrumbPaths} />
                </div>
                <ContractsTable />
                <div className={`fixed w-full h-full inset-0 transition-opacity duration-100 ${contractId ? 'z-50 opacity-100' : '-z-1 opacity-0'}`} onClick={() => router.push(`/contracts?${originalQueryString}`)}>
                    <div class="absolute w-full h-full bg-gray-900 opacity-50" />
                    <div class="modal-content p-3 absolute bg-white w-full md:w-11/12 md:max-w-2xl md:mx-auto md:rounded md:shadow-lg z-50 overflow-y-auto max-h-screen" onClick={(e) => e.stopPropagation()}>
                        <div className="flex justify-end">
                            <Link href={`/contracts?${originalQueryString}`}>
                                <a>
                                    <button>
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </a>
                            </Link>
                        </div>
                        {contractSelected ? (
                            <>
                                <div className="mb-6">
                                    <div className="flex justify-between items-center">
                                        <div className="min-w-0">
                                            <p className="text-xl font-bold">{contractSelected.result.name}</p>
                                            <p className="text-sm text-gray-700 truncate">#{contractSelected.result._id}</p>
                                        </div>
                                        <div className="text-right">
                                            <div className="flex justify-end items-center space-x-2 mb-1">
                                                <p className={`label text-center ${getContractValidity(contractSelected.result).intent}`}>{getContractValidity(contractSelected.result).label}</p>
                                                <p className="label text-center info">{contractStatusLabel(contractSelected.result)}</p>
                                            </div>
                                            <p className="text-gray-700 text-sm tracking-tight">{isExpired(contractSelected.result) ? 'Expirou em' : 'Expira em'}: {dayjs(contractSelected.result.expires_at).format('DD/MM/YYYY hh:mm:ss')}</p>
                                        </div>
                                    </div>
                                    <div className="box w-full mt-6">
                                        <div className="flex justify-between items-center">
                                            <div className="text-left min-w-0">
                                                <p className="text-md font-bold">Taxas</p>
                                            </div>
                                        </div>
                                        { contractSelected?.result?.paymentRules?.map(paymentRule => (
                                            <div className="box">
                                                <div className="flex justify-between items-center border-b mb-2">
                                                    <p className="text-md tracking-tight font-bold">{methodParser[paymentRule.method]} - {paymentRule.installments > 1 ? `${paymentRule.installments}x` : 'À vista'}</p>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <p className="text-md">Absorver: {paymentRule.take_rate.zero_tax}%</p>
                                                    <p className="text-md">Repassar: {paymentRule.take_rate.default}%</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="w-full py-12">
                                <Loader /> 
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Layout>
    )
}
